import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  modalBox: {
    border: '1px solid red'
  },
  modalTitle: {
    color: theme.palette.blue_300.main
  },
  modalFormTitle: {
    fontWeight: '600',
    color: theme.palette.gray_400.main
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },

  extraInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  },
  titleExtraInfo: {
    color: theme.palette.gray_400.main,
    fontWeight: '600'
  },
  actionItemButton: {
    color: theme.palette.red_100.main,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.blue_400.main
    }
  },
  extraInfoButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    '& button': {
      width: '100%',
      borderRadius: '8px',
      border: '1px solid' + theme.palette.blue_300.main,
      color: theme.palette.blue_300.main,
      textTransform: 'capitalize'
    },
    '& button:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },

  buttonSave: {
    boxShadow: 'none',
    borderRadius: '8px',
    '&:hover': {
      boxShadow: 'none'
    }
  },

  buttonProgress: {
    color: theme.palette.green_200.main,
    position: 'absolute',
    top: '12%',
    left: '50%',
    marginLeft: -12
  },

  emptyTags:{
    color: theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif'
  },
  tags:{
    display: 'flex',
  },
  tagsList:{
    display: 'flex',
    gap: '4px',
  },
  badgeItem: {
    borderRadius: '4px',
    fontSize: '12px',
    height: '20px',
    color: theme.palette.white_100.main
  },


  dialogWarning:{
    '& .MuiDialog-paper': {
      width: '400px',
      maxWidth: '400px',
      borderRadius: '8px'
    }

  },
  warningContainer:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    '& svg':{
      color: theme.palette.red_100.main,
    }
  },
  dialogWarningTitle:{
    '& .MuiDialogTitle-root':{
      padding: '0 !important'
    }
  },
  warningTitle:{
    fontSize: '1.6rem',
    fontWeight: '600',
    color: theme.palette.red_100.main,
  },
  warningDescription:{
    fontWeight: '400',
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main  : theme.palette.gray_400.main,
  }
}))
